<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item to="/">首页</el-breadcrumb-item>
        <el-breadcrumb-item>财务中心设置管理</el-breadcrumb-item>
        <el-breadcrumb-item>{{ $route.meta.title }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <layout-panel>
      <span slot="header">表单</span>
      <el-form ref="form"
               :model="form"
               size="medium"
               label-width="140px"
               @submit.native.prevent="onSubmit()">
        <div class="re-el-form__flex">
          <div class="medium">
            <el-form-item label="选择Excel">
              <department-job-batch-excel
                ref="departmentJobExcel"
                @excelFileRemove="excelFileRemove"
                @change-file="(_) => this.file = _"
                @change="(_) => this.form.data = _"
              />
            </el-form-item>

            <el-form-item label="上传进度">
              <div style="margin-top: 8px">
                <el-progress v-if="percentage < 100"
                            :percentage="percentage"
                            :stroke-width="18"
                            color="#666666">
                </el-progress>
                <el-progress v-if="percentage === 100"
                            :percentage="100"
                            :stroke-width="18"
                            status="success">
                </el-progress>
              </div>
            </el-form-item>

            <el-form-item label="错误记录">
              <template>
                <div v-for="(item) in error_data">
                  <span>{{ item }}</span>
                </div>
              </template>
            </el-form-item>

          </div>
        </div>
        <el-form-item>
          <el-button type="primary"
                     native-type="submit">开始上传
          </el-button>
          <el-button @click="onReload">重置</el-button>
        </el-form-item>
      </el-form>
    </layout-panel>
  </div>
</template>

<script>
import DepartmentJobBatchExcel from '../components/DepartmentJobBatchExcel'

export default {
  components: {DepartmentJobBatchExcel},
  data () {
    return {
      form: {
        data: [],
      },
      error_data: [],
      percentage: 0,
      file: null,
      fileHeader: [],
    }
  },
  computed: {},
  watch: {},
  beforeRouteUpdate (to, from, next) {
    this.onReload()
    next()
  },
  created () {},
  mounted () {},
  methods: {
    ...request.map([]),
    onReload () {
      Object.assign(this.$data, this.$options.data.call(this))
      this.$refs.userBankExcel.$refs.userBankBatchExcel.clearFiles()
    },
    getFormData () {
      return _.cloneDeep(this.form.data)
    },
    onSubmit () {
      if (this.form.data.length === 0) {
        this.$message.error('请选择文件')
      } else {
        this.create()
      }
    },
    excelFileRemove (fileList) {
      if (fileList.length === 0) {
        this.form.data = []
      }
    },
    async create () {
      let data = this.getFormData()
      this.error_data = []
      for (let index = 0; index < data.length; index++) {
        let param = data[index]
        let num = index + 1
        this.percentage = (num / data.length) * 100

        let info = '第' + num + '行 '
        if (this.checkParams(param, info)) {
          try {
            await request.loading('batchCreateDepartmentJob', param)
          } catch (error) {
            this.error_data.push(info + error.message)
          }
        }
      }
    },
    checkParams (param, info) {
      let err = ''
      let rule = {
        department_name: '部门名称',
        name: '岗位名称',
      }

      for (const ruleKey in rule) {
        if (!param[ruleKey]) {
          err = rule[ruleKey] + ' 为空'
          break
        }
      }
      if (err) {
        this.error_data.push(info + err)
        return false
      }
      return true
    }
  },
}
</script>
<style lang="scss">
// 全局CSS
</style>
<style lang="scss"
       scoped>
// 带作用域的CSS
// https://vue-loader.vuejs.org/zh-cn/features/scoped-css.html
</style>
<style lang="scss"
       module>
// 带作用域的CSS
// 绑定class方式 <p :class="$style.red"></p>
// https://vue-loader.vuejs.org/zh-cn/features/css-modules.html
</style>



// WEBPACK FOOTER //
// src/views/finance-config/pages/FinanceDepartmentJobBatchForm.vue